// TODO:: 持たせ方見直したい
export const PriceType = {
  price_a: {title: "単価A(施設献立価格）", value: 'price_a'},
  price_b: {title: "単価B (配食用)", value: 'price_b'},
  price_c: {title: "単価C (彩膳用)", value: 'price_c'},
  price_d: {title: "単価D (単品用)", value: 'price_d'},
  price_e: {title: "単価E", value: 'price_e'},
} as const;